// src/components/atoms/ViewToggle/ViewToggle.jsx
import React from 'react';
import PropTypes from 'prop-types';
import { ToggleButtonGroup, ToggleButton, Tooltip, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  Assessment as AssessmentIcon,
  Description as DescriptionIcon,
  FormatListBulleted as FormatListBulletedIcon
} from '@mui/icons-material';
import {
  operationalRadii,
  operationalSizing,
  operationalSpacing
} from '../../../design-system/tokens';

/**
 * ViewToggle - Componente para alternar entre modos de visualizacao.
 */
const ViewToggle = ({
  value,
  onChange,
  size = 'medium',
  className = '',
  ...props
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const allViewOptions = [
    { value: 'detailed', icon: DescriptionIcon, tooltip: 'Visualizacao Detalhada' },
    { value: 'list', icon: FormatListBulletedIcon, tooltip: 'Visualizacao em Lista' },
    { value: 'measurement', icon: AssessmentIcon, tooltip: 'Modo Mensuracao' }
  ];

  const viewOptions = isMobile
    ? allViewOptions.filter(option => option.value !== 'list' && option.value !== 'measurement')
    : allViewOptions;

  return (
    <ToggleButtonGroup
      value={value}
      exclusive
      onChange={onChange}
      size={size}
      className={`view-toggle ${className}`}
      sx={{
        height: operationalSizing.compact,
        borderRadius: `${operationalRadii.control}px`,
        ...props.sx
      }}
      {...props}
    >
      {viewOptions.map((option) => {
        const Icon = option.icon;
        return (
          <ToggleButton
            key={option.value}
            value={option.value}
            sx={{
              minWidth: operationalSizing.compact,
              height: operationalSizing.compact,
              px: operationalSpacing.sm,
              borderRadius: `${operationalRadii.control}px`,
              '&.Mui-selected': {
                color: 'primary.main',
                backgroundColor: 'action.selected',
                '& svg': {
                  color: 'primary.main',
                },
                '&:hover': {
                  backgroundColor: 'action.hover',
                },
              },
            }}
          >
            <Tooltip title={option.tooltip} arrow>
              <Icon sx={{ fontSize: '1.3rem' }} />
            </Tooltip>
          </ToggleButton>
        );
      })}
    </ToggleButtonGroup>
  );
};

ViewToggle.propTypes = {
  value: PropTypes.oneOf(['detailed', 'list', 'measurement']).isRequired,
  onChange: PropTypes.func.isRequired,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string
};

export default ViewToggle;
